import { Divider } from "@mui/material"
import { Outlet } from "react-router-dom"
import { Stack } from "src/shared/components"
import Sidebar from "./sidebar"
import Navbar from "./navbar"
import { useGlobalConfig } from "src/shared/context/globalConfigContext"

export const sidebarWidth = {
  wide: "240px",
  narrow: "80px"
}
const MainLayout = () => {
  const { isSidebarOpen, toggleSidebar } = useGlobalConfig()
  return (
    <Stack
      id="main-layout"
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        transition: theme =>
          theme.transitions.create(["padding"], {
            duration: theme.transitions.duration.standard
          }),
        pl: { xs: "0px", md: isSidebarOpen ? sidebarWidth.wide : sidebarWidth.narrow }
      }}
    >
      <Stack sx={{ position: "sticky", top: 0, background: theme => theme.palette.background.default }}>
        <Navbar toggleSidebar={toggleSidebar} />
        <Divider />
      </Stack>

      <Stack id="main-layout-body" sx={{ flex: 1, overflow: "auto" }}>
        <Outlet />
      </Stack>
      <Sidebar />
    </Stack>
  )
}

export default MainLayout
